<template>
    <DModal
        is-confirm
        :title="__('customers.orders.modal.manage_order_person_title')"
        :show="showModal"
        @confirm="confirm"
        @close="close"
    >
        <DForm
            class="manage-person-form"
        >
            <DFormRow
                v-if="contacts.length"
                :label="__('customers.orders.order_person')"
                is-required
            >
                <DSelect
                    id="order_person"
                    v-model="selectedContact"
                    :placeholder="__('customers.orders.order_person')"
                    :options="contactList"
                />
            </DFormRow>
            <span v-else>{{ __('customers.orders.no_contacts_found') }}</span>
        </DForm>
    </DModal>
</template>

<script>

export default {
    name: 'ManageOrderPersonModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        contacts: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['confirm', 'close-modal'],
    data () {
        return {
            selectedContact: null
        }
    },
    computed: {
        contactList () {
            const contactSelect = this.contacts.map(contact => {
                return {
                    value: contact.id,
                    label: contact.firstname + ' ' + contact.lastname
                }
            })
            contactSelect.unshift({
                value: null,
                label: this.__('customers.orders.no_order_person')
            })
            return contactSelect
        }
    },
    methods: {
        confirm () {
            this.$emit('confirm', this.selectedContact)
        },
        close () {
            this.$emit('close-modal')
        }
    }
}
</script>

<style scoped>
.manage-person-form {
    padding: 20px
}
</style>
